import * as Yup from "yup";

export const referredSchema = Yup.object().shape({
  // Referral details
  //   referral_date: Yup.string().required("Referral date is required"),
  referred_to_state: Yup.mixed().required("State is required"),
  referred_to_district: Yup.mixed().required("District is required"),
  referred_to_dccc: Yup.mixed().required("DCCC is required"),
  //   referred_to_dcc_name: Yup.string().required("DCC name is required"),

  //   // Chemo drug summary
  // //   chemo_drug_name: Yup.string().required("Chemo drug name is required"),
  // //   chemo_drug_dosage: Yup.string().required("Chemo drug dosage is required"),
  // //   final_calculated_chemo_drug_dosage: Yup.string().required("Final calculated dose is required"),
  // //   route_of_drug_administration: Yup.string().required("Route of administration is required"),
  planned_chemo_cycles: Yup.number()
    .typeError("Planned chemo cycles must be a number")
    .required("Planned chemo cycles is required"),
  //   chemo_infusion_rate_duration: Yup.number()
  //     .typeError("Infusion rate/duration must be a number")
  //     .required("Infusion rate/duration is required"),
  //   chemo_diluent_volume: Yup.number()
  //     .typeError("Diluent volume must be a number")
  //     .required("Diluent volume is required"),
  //   chemo_timing: Yup.mixed().required("Chemo timing is required"),
  //   chemo_delivery_method: Yup.string().required("Delivery method is required"),
  //   chemo_notes_special_instructions: Yup.string().required("Notes / special instructions are required"),

  //   // Premedication summary
  // //   chemp_premedication_drug_name: Yup.string().required("Premedication drug name is required"),
  // //   chemo_drug_dose: Yup.number()
  // //     .typeError("Chemo drug dose must be a number")
  // //     .required("Chemo drug dose is required"),
  // //   chemo_administration_route: Yup.string().required("Chemo administration route is required"),

  //   // Arrays: drug_details & premedication_details
  //   drug_details: Yup.array()
  //     .of(
  //       Yup.object().shape({
  //         drug_name: Yup.string().required("Drug name is required"),
  //         dosage: Yup.string().required("Dosage is required"),
  //         final_dose: Yup.string().required("Final calculated dose is required"),
  //         route_admin: Yup.string().required("Route is required"),
  //       })
  //     )
  //     .min(1, "At least one drug is required")
  //     .required("Drug details are required"),

  //   premedication_details: Yup.array()
  //     .of(
  //       Yup.object().shape({
  //         drug_name: Yup.string().required("Premedication drug name is required"),
  //         drug_dose: Yup.string().required("Premedication dose is required"),
  //         administration_route: Yup.string().required("Premedication route is required"),
  //       })
  //     )
  //     .min(1, "At least one premedication is required")
  //     .required("Premedication details are required"),

  //   // Hydration plan - Pre
  //   pre_chemo_hydration_fluid_type: Yup.string().required("Pre-chemo fluid type is required"),
  //   pre_chemo_hydration_fluid_volume: Yup.string().required("Pre-chemo fluid volume is required"),
  //   pre_chemo_hydration_fluid_duration: Yup.string().required("Pre-chemo fluid duration is required"),

  //   // Hydration plan - Post
  //   post_chemo_hydration_fluid_type: Yup.string().required("Post-chemo fluid type is required"),
  //   post_chemo_hydration_fluid_volume: Yup.string().required("Post-chemo fluid volume is required"),
  //   post_chemo_hydration_fluid_duration: Yup.string().required("Post-chemo fluid duration is required"),
});
